/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import SupportRequestRepository from '../../repositories/Admin/SupportRequestRepository';
import { createRestSlice } from '../../utils/RestSlice';
import DatePresenter from '../../presenters/DatePresenter';

const supportRequestsRestSlice = createRestSlice({
  resource: 'supportRequest',
  repository: SupportRequestRepository,
  slices: ['loadSupportRequests', 'loadSupportRequest', 'updateSupportRequest'],
});

const initialState = {
  ...supportRequestsRestSlice.initialState,
  afterDate: DatePresenter.oneMonthAgo(),
  beforeDate: DatePresenter.today(),
  auth0Id: '',
};

const supportRequestsSlice = createSlice({
  name: 'supportRequests',
  initialState,
  reducers: {
    ...supportRequestsRestSlice.reducers,
    changeStartdate: (state, action) => {
      state.afterDate = action.payload;
    },
    changeEndate: (state, action) => {
      state.beforeDate = action.payload;
    },
    changeAuth0Id: (state, action) => {
      state.auth0Id = action.payload;
    },
  },
});

export const { changeStartdate, changeEndate, changeAuth0Id } =
  supportRequestsSlice.actions;
export const selectStartdate = (state) =>
  state.admin.SupportRequestsSlice.afterDate;
export const selectEndate = (state) =>
  state.admin.SupportRequestsSlice.beforeDate;
export const selectAuth0Id = (state) =>
  state.admin.SupportRequestsSlice.auth0Id;
export default supportRequestsSlice.reducer;

export const supportRequestsRestHooks = supportRequestsRestSlice.hooks(
  supportRequestsSlice,
  ['admin', 'SupportRequestsSlice']
);
